$(document).ready(function() {
	if(!document.querySelector('.resource-search-area')) return false;

	// form
	var form = {
		el: document.getElementById('resourceSearchForm'),

		// define form elements
		superCategoryId: document.getElementById('superCategorySelect_hl'),
		categoryId: document.getElementById('subCategorySelect_hl'),
		symptom: document.getElementById('symptomSelect_hl'),
		subsymptom: document.getElementById('subsymptomSelect_hl'),
		detailsymptom: document.getElementById('detailsymptomSelect_hl'), //LGCOMMON-11630 START
		search: document.querySelector('.search-common-input'),
		//LGECI-538 Add
		sortBy: document.getElementById('sortBy'),
		totalUse : document.querySelector('#subCategorySelect_hl_pc'),

		// to be defined form elements in form.init Function
		$topic: null,
		$selectors: null,
		$expander: null,

		init: function(){
			form.$topic = $(form.el).find('.topic-selector');
			form.$selectors = $(form.el).find('select');
			form.$expander = $(form.el).find('.expander button');
			form.$url = $(form.el).find('input[name=url]');

			$(form.superCategoryId).drawAjaxOptions({
				setTarget: form.categoryId,
				addParam: [ form.$url ]
			});
			$(form.categoryId).drawAjaxOptions({
				setTarget: form.symptom,
				addParam: [ form.superCategoryId, form.$url ]
			});
			$(form.symptom).drawAjaxOptions({
				setTarget: form.subsymptom,
				addParam: [ form.superCategoryId, form.categoryId, form.$url ]
			});
			//LGCOMMON-11630 START
			if (symptomDepthSetupValue === 'Y') {
			$(form.subsymptom).drawAjaxOptions({
				setTarget: form.detailsymptom,
				addParam: [ form.superCategoryId, form.categoryId, form.symptom, form.$url ]
			})
			};
			//LGCOMMON-11630 END

			form.addEvent();
			//LGECI-538 add
			if(form.totalUse && '' != $('input[name=search]').val()){
				$('.resource-search-results-wrap').attr('style','display');
			};
		},
		//LGECI-538 START
		doSubmitTotal : function(t){
			var _this = t;
			var url = form.el.getAttribute('data-url');
			/*LGECI-668 start */
			var formUrl = form.el.url.value;
			if(typeof formUrl == 'undefined'){
				formUrl = 'help-library'
			}
			var param_f = "url="+formUrl+""+"&superCategoryId="+$('#superCategoryIdTotal').val()+"&categoryId="+$('#categoryIdTotal').val()
			/*LGECI-668 end */
			results.setTags(_this, true);
			
			if(_this.id == form.categoryId.id || _this.getAttribute('data-area') == form.categoryId.id) {
				results.setTags(_this, true); // condition tag;
				results.$tabContents.find('input.page')[0].value = 1;
				results.$tabContents.find('input.page')[1].value = 1;
			}
			
			if(form.el.search.value != '') {
				results.setTags(_this, false); // seach keyword tag;
				var searchIdx = form.el.getAttribute('data-search-idx');
				searchCommon[searchIdx].doSubmit(true); // bake cookie for search keyword
				SubmitdetailPage.search.value = form.el.search.value; // submitDetailPage data replace
				param_f = param_f + "&keyword=" + form.el.search.value;
				results.$tabContents.find('input.page')[0].value = 1;
				results.$tabContents.find('input.page')[1].value = 1;
			}
			
			var i = 0;
			var len = results.$carousels.length;
			function loopSet(){ 
				var $this = results.$carousels.eq(i);
				var $thisWrapper = results.$carouselWrappers.eq(i);
				var $thisContents = results.$tabContents.eq(i);
				var param = param_f + '&' + $thisContents.find('input').serialize();
				
				ajax.call(url, param, 'html', function(data){
					$(results.el).find('.area-body').hide();
					$(results.el).find('.service-result').show(); // LGEID-286

					var isNotEmpty = (data && (data !== false || data !== null));
					var itemCount;

					if(isNotEmpty && $(data).filter('.item-list')[0]){
						itemCount = $(data).filter(".item-list").attr("data-item-count");
						$this.remove();
						$thisWrapper.html('<div class="item-carousel">'+data+'</div>');
						$thisContents.find('.total-items').text((itemCount && itemCount != null) ? itemCount : 0);
						results.drawPaging($thisWrapper.closest(".item-column"));

						i++;

						if (i < len) loopSet();
						else {
							var resultCount = $(data).filter(".item-list").attr("data-result-count");
							$(results.el).find(".number").text((resultCount && resultCount != null) ? resultCount : '');
							$(results.el).find('.have-result').show();
							$('body').trigger('ajaxLoadEnd');
						}
					}else {
						// is error
						$(results.el).find(".number").text("");
						$(results.el).find('.no-result').show();
						$(results.el).find('.total-items').text("0");
						$('body').trigger('ajaxLoadEnd');
					}
				});
			}
			$('body').trigger('ajaxLoadBefore');
			loopSet();
			$('.resource-search-results-wrap').attr('style','display');
		},
		//LGECI-538 END
		doSubmit: function(t){
			var _this = t;
			var url = form.el.getAttribute('data-url');
			var param_f = xssfilter($(form.el).serialize());

			// set tags
			//LGCOMMON-11630 START
			if(_this.id == form.superCategoryId.id || _this.getAttribute('data-area') == form.superCategoryId.id){
				// page reset
				results.$tabContents.find('input.page')[0].value = 1;
				results.$tabContents.find('input.page')[1].value = 1;
			}
			//LGCOMMON-11630 END
			/* LGEBR-94 : 20200703 modify */
			if(_this.id == form.categoryId.id || _this.getAttribute('data-area') == form.categoryId.id) {
				/* LGEBR-94 : 20200703 modify */
				results.setTags(_this, true); // condition tag;
				// page reset
				results.$tabContents.find('input.page')[0].value = 1;
				results.$tabContents.find('input.page')[1].value = 1;
			}
			/* LGECI-538 : 20211026 modify */
			if(!form.totalUse){
				if(_this.id == form.symptom.id || _this.id == form.subsymptom.id) {
					// page reset
					results.$tabContents.find('input.page')[0].value = 1;
					results.$tabContents.find('input.page')[1].value = 1;
				}
			}else{
				$('.resource-search-results-wrap').attr('style','display');
			}
			/* LGECI-538 : 20211026 modify */
			if(form.el.search.value != '') {
				results.setTags(_this, false); // seach keyword tag;
				var searchIdx = form.el.getAttribute('data-search-idx');
				searchCommon[searchIdx].doSubmit(true); // bake cookie for search keyword
				SubmitdetailPage.search.value = form.el.search.value; // submitDetailPage data replace
				// page reset
				results.$tabContents.find('input.page')[0].value = 1;
				results.$tabContents.find('input.page')[1].value = 1;
			}
			
			// loop function for async ajax
			var i = 0;
			var len = results.$carousels.length;
			// 200402 START 전호근 - pagination 추가 관련
			function loopSet(){ 
				// for(var i=0; i<len; i++) {
				var $this = results.$carousels.eq(i);
				var $thisWrapper = results.$carouselWrappers.eq(i);
				var $thisContents = results.$tabContents.eq(i);
				var param = param_f + '&' + $thisContents.find('input').serialize();
				
				ajax.call(url, param, 'html', function(data){
					$(results.el).find('.area-body').hide();
					$(results.el).find('.service-result').show(); // LGEID-286

					var isNotEmpty = (data && (data !== false || data !== null));
					var itemCount;

					if(isNotEmpty && $(data).filter('.item-list')[0]){
						itemCount = $(data).filter(".item-list").attr("data-item-count");
						$this.remove();
						$thisWrapper.html('<div class="item-carousel">'+data+'</div>');
						$thisContents.find('.total-items').text((itemCount && itemCount != null) ? itemCount : 0);
						results.drawPaging($thisWrapper.closest(".item-column"));

						i++;

						if (i < len) loopSet();
						else {
							var resultCount = $(data).filter(".item-list").attr("data-result-count");
							$(results.el).find(".number").text((resultCount && resultCount != null) ? resultCount : '');
							$(results.el).find('.have-result').show();
							//LGECI-538 Start
							if(form.totalUse){
								if(parseInt(resultCount) >= 6){
									var moreBtn = $('.expander.total');
									for(var x = 0; x < moreBtn.length; x++){
										if(!$(moreBtn[x]).hasClass('visible-mobile')){
											$(moreBtn[x]).addClass('visible-mobile');
											$(moreBtn[x]).find('button').attr("style","display");
										}
									}
								}else{
									$('.expander.total').removeClass('visible-mobile');
									$('.expander.total').find('button').attr("style","display:none");
								}
								$('.expander button.btn-load-more').val(1);
							}
							//LGECI-538 End
							$('body').trigger('ajaxLoadEnd');
						}
					}else {
						// is error
						$(results.el).find(".number").text("");
						$(results.el).find('.no-result').show();
						$(results.el).find('.total-items').text("0");
						$('body').trigger('ajaxLoadEnd');
					}
				});
			}
			$('body').trigger('ajaxLoadBefore');
			loopSet();
			// 200402 END 전호근 - pagination 추가 관련
			// loop function for async ajax end;
		},
		addEvent: function(){
			// selector events
			$(form.superCategoryId).on({
				'change.base': function(){
					form.$topic.removeClass('active');
					SubmitdetailPage.superCategoryId.value = this.value;
					SubmitdetailPage.categoryId.value = '';
					/* LGECI-538 : 20211026 modify */
					if(!form.totalUse){
					SubmitdetailPage.symptom.value = '';
					SubmitdetailPage.subsymptom.value = '';
					//LGCOMMON-11630 START
					if (symptomDepthSetupValue === 'Y') {
					SubmitdetailPage.detailsymptom.value = '';
					form.detailsymptom.value = '';
					form.detailsymptom.disabled = true;
					}
					//LGCOMMON-11630 END
					form.categoryId.value = '';
					form.symptom.value = '';
					form.subsymptom.value = '';
					form.symptom.disabled = true;
					form.subsymptom.disabled = true;
					}else{
						$('#superCategoryIdTotal').val(this.value);
					}
					/* LGECI-538 : 20211026 modify */
					form.$selectors.trigger('chosen:updated');
					form.doSubmit(this);
				}
			});
			$(form.categoryId).on({
				'change.base': function(){
					form.$topic.addClass('active');
					SubmitdetailPage.categoryId.value = this.value;
					/* LGECI-538 : 20211026 modify */
					if(!form.totalUse){
					SubmitdetailPage.symptom.value = '';
					SubmitdetailPage.subsymptom.value = '';
					//LGCOMMON-11630 START
					if (symptomDepthSetupValue === 'Y') {
					SubmitdetailPage.detailsymptom.value = '';
					form.detailsymptom.value = '';
					form.detailsymptom.disabled = true;
					}//LGCOMMON-11630 END 
					form.symptom.value = '';
					form.subsymptom.value = '';
					form.subsymptom.disabled = true;
					}else{
						$('#categoryIdTotal').val(this.value);
					}
					/* LGECI-538 : 20211026 modify */
					form.$selectors.trigger('chosen:updated');
					form.doSubmit(this);
				}
			});
			$(form.symptom).on({
				'change.base': function(){
					SubmitdetailPage.symptom.value = this.value;
					SubmitdetailPage.subsymptom.value = '';
					//LGCOMMON-11630 START
					if (symptomDepthSetupValue === 'Y') {
					SubmitdetailPage.detailsymptom.value = '';
					form.detailsymptom.value = '';
					form.detailsymptom.disabled = true;
					}
					//LGCOMMON-11630 END
					form.subsymptom.value = '';
					form.$selectors.trigger('chosen:updated');

					form.doSubmit(this);
				}
			});
			$(form.subsymptom).on({
				'change.base': function(){
					SubmitdetailPage.subsymptom.value = this.value;
					//LGCOMMON-11630 START
					if (symptomDepthSetupValue === 'Y') {
					SubmitdetailPage.detailsymptom.value = '';
					form.detailsymptom.value = '';
					form.$selectors.trigger('chosen:updated');
					}
					//LGCOMMON-11630 END
					form.doSubmit(this);
				}
			});
			$(form.detailsymptom).on({
				'change.base': function(){
					SubmitdetailPage.detailsymptom.value = this.value;
					form.doSubmit(this);
				}
			});
			/* LGECI-538 START */
			$(form.sortBy).on({
				'change': function(){
					var sortName = $(this).val();
					if(sortName == "newest"){
						$('.item-columns-wrap .newest').attr('style','display').addClass('active');
						$('.item-columns-wrap .popular').attr('style','display:none').removeClass('active');
					}else{
						$('.item-columns-wrap .popular').attr('style','display').addClass('active');
						$('.item-columns-wrap .newest').attr('style','display:none').removeClass('active');
					}
				}
			});
			/* LGECI-538 END */

			// selector events end

			// advanced Search btn for mobile
			form.$expander.on({
				click: function(){
					if(!$(form.el).hasClass('expanded')) {
						$(form.el).addClass('expanded');
						// auto focus;
						$(form.el).find('.chosen-container input').eq(0).focus();
					}else {
						$(form.el).removeClass('expanded');
					}
				}
			});
			/* LGECI-538 START */
			var superCateTabs = $('#superCategorySelect_hl_pc').find('[role="tab"]'),
			subCatePanel = $('#subCategorySelect_hl_pc').find('[role="tabpanel"]'),
			subCateBtn = $('#subCategorySelect_hl_pc').find('button'),
			superCategoryIdTotal = $('#superCategoryIdTotal').val(),
			categoryIdTotal =  $('#categoryIdTotal').val(),
			subInitPanel = 0;
			
			if(null != superCategoryIdTotal && undefined != superCategoryIdTotal && "" != superCategoryIdTotal){
				for(var a = 0 ; a < superCateTabs.length ; a++){
				    if($(superCateTabs[a]).val() == superCategoryIdTotal){
				    	superCateTabs.removeClass('active').attr('aria-selected','false');
				        $(superCateTabs[a]).addClass('active').attr('aria-selected','true');
				        subInitPanel = a;
				    }
				}
			}
			if(null != categoryIdTotal && undefined != categoryIdTotal && "" != categoryIdTotal){
				subCatePanel.removeClass('active');
				subCateBtn.removeClass('active');
				$(subCatePanel[subInitPanel]).addClass('active');
				for(var a = 0 ; a < subCateBtn.length ; a++){
				    if($(subCateBtn[a]).val() == categoryIdTotal){
				        $(subCateBtn[a]).addClass('active');
				    }
				}
			}
			superCateTabs.on('click',function(){
				var isAct = $(this).hasClass('active');
				if(!isAct) {
					var target = '#' + $(this).attr('aria-controls');
					superCateTabs.removeClass('active').attr('aria-selected','false');
					$(this).addClass('active').attr('aria-selected','true');
					subCatePanel.removeClass('active');
					$(target).addClass('active').focus();
				}
			});
			subCateBtn.on('click',function(){
				var isAct = $(this).hasClass('active');
				if(!isAct) {
					subCateBtn.removeClass('active');
					$(this).addClass('active');
					$('#superCategoryIdTotal').val($('#superCategorySelect_hl_pc').find('[role="tab"].active').val());
					$('#categoryIdTotal').val($(this).val());
					form.doSubmitTotal(this);
				}
			});
			/* LGECI-538 END */
		}
	};

	// 200402 START 전호근 - pagination 추가 관련
	// results area
	var results = {
		// define elements
		el: document.querySelectorAll('.resource-search-results-wrap'), //LGEBR-407
		// to be defined elements in results.init Function
		$tabContents: null,
		$carouselWrappers: null,
		$carousels: null,
		$tabs: null,
		$tags: null,
		$expander: null,
		$pagination: null,
		init: function(){
			results.$carouselWrappers = $(results.el).find('.column-body');
			results.$carousels = results.$carouselWrappers.find('.item-carousel');
			results.$tabContents = $(results.el).find('.item-column');
			results.$tabs = $(results.el).find('.item-tab-wrap');
			results.$tags = $(results.el).find('.tag-wrap');
			results.$expander = $(results.el).find('.expander.total button.btn-load-more');
			// pagination
			results.$pagination = $(results.el).find('.pagination');

			results.addEvent();
		},
		// top results summary tag function
		setTags: function(t, isCondition){
			var _this = t;
			var keyword = $.trim(form.el.search.value) != "" ? $(form.el.search).serialize() : "";
			var param = isCondition ? keyword : $(form.el.selectorField).serialize();
			var url = form.el.action + (param == "" ? "" : "?") + param;
			var $target, text;
			$(results.el).find('.results-summary .desc').addClass('active');
			if(isCondition) {
				$target = results.$tags.find('.condition');
				/* LGEBR-94 : 20200703 modify */
				if(form.categoryId.options){
					text = form.categoryId.options[form.categoryId.selectedIndex].text;
				}else{
					text = $(_this).find('.text').text();
				}				
				/*// LGEBR-94 : 20200703 modify */
				/* LGECI-538 : 20211026 modify */
				if(form.totalUse &&  '' != $('#subCategorySelect_hl_pc').find('button.active').text() && window.innerWidth >= 768){
					text = $('#subCategorySelect_hl_pc').find('button.active').text();
				}
				/* LGECI-538 : 20211026 modify */
			}else {
				$target = results.$tags.find('.keyword');
				text = form.search.value;
			}
			$target.find('a')[0].href = url;
			$target.find('.text').text(text);

			$target.addClass('active');
		},
		callData: function(t,u){
			var $thisItem = t;
			var $thisCarousel = u;

			var url = form.el.getAttribute('data-url');
			var param_f = xssfilter($(form.el).serialize());
			var param = param_f + '&' + $thisItem.find('input').serialize();

			ajax.call(url, param, 'html', function(data){
				$thisCarousel.html(data);
				results.addAriaRoldAttr($thisCarousel);
			}, 'post', 'body');

			/* LGECI-260 201228 add :: [LGECI-260] [web accessibility] paging num tab -> focus to list first item */
			setTimeout(function() {
				$thisCarousel.find("a").eq(0).focus();
			}, 500);
			/* // LGECI-260 201228 add */
		},
		/* LGECI-538 START */
		callMobileData: function(t,u,c){
			var $thisItem = t;
			var $thisCarousel = u;
			var $thisButton = c;
			var countrycode = $('html').data('countrycode'); 
			
			var url = "/"+countrycode+"/support/helplibraryTotal.lgajax"
			var param_f = xssfilter($(form.el).serialize());
			var param = param_f + '&' + $thisItem.find('input').serialize();

			ajax.call(url, param, 'json', function(data){
				var resourceList = data.popularList;
				if(resourceList == undefined){
					resourceList = data.list;
				}
				var resourceListHtml = "";
				for(var i = 0; i < resourceList.length; i++){
					resourceListHtml += "<div class='item article'><div class='visual icon'>";
					if(resourceList[i].isVideo == 'true'){
						resourceListHtml += '<span class="icon"><img src="/lg5-common-gp/images/support/icons/shooting.svg" alt="'+data.videoContentsMessage+'"></span></div>';
					}else{
						resourceListHtml += '<span class="icon"><img src="/lg5-common-gp/images/support/icons/document.svg" alt="'+data.documentContentsMessage+'"></span></div>';
					}
					resourceListHtml += '<div class="summary"><div class="metadata"><span class="type">'+resourceList[i].eyebrow+'</span><span class="category">'+resourceList[i].category+'</span></div><h3 class="subject"><a href="';
					resourceListHtml += resourceList[i].linkURL+'" data-link-area="cs_help_library_list_view_detail" data-link-name="'+resourceList[i].articleTitle+'">';
					if(resourceList[i].itemtopflag == 'Y'){
						resourceListHtml += '<span class="recommendation">'+data.listLgPickMessage+'</span>';
					}
					resourceListHtml += resourceList[i].title+'</a></h3><input type="hidden" class="resultSeq" name="resultSeq" value="'+resourceList[i].resultSeq+'"></div></div>';
				}
				$thisCarousel.find('.item-list').html($thisCarousel.find('.item-list').html()+resourceListHtml);
				results.addAriaRoldAttr($thisCarousel);
			}, 'post', 'body');

			setTimeout(function() {
				$thisButton.focus();
			}, 500);
		},
		/* LGECI-538 END*/
		drawPaging: function($thisColumn, $thisButton) {
			var $thisPagination = $thisColumn.find('.pagination ul li');

			var html = '',
				firstPage = parseInt($thisPagination.filter(':first').text()),
				totalPage = Math.ceil($thisColumn.find('.item-list').data('itemCount') / 5),
				lastPage = firstPage + 4;

			if ($thisButton != undefined) {
				if ($thisButton.is('.prev')) {
					firstPage -= 5;
					lastPage = firstPage + 4;
				} else if ($thisButton.is('.next')) {
					firstPage += 5;
					lastPage = firstPage + 4;
					if (lastPage > totalPage) {
						lastPage = totalPage;
					}
				}

				if ($thisButton.html() > lastPage) {
					firstPage = $thisButton.html() - ($thisButton.html() - 1)%5;
					lastPage = $thisButton.html();
				}
			} else {
				firstPage = 1;
				lastPage = 5;
			}

			if (lastPage > totalPage) {
				lastPage = totalPage;
			}

			for (var i = firstPage; i <= lastPage; i++) {
				html += '<li>';
				if (!$thisButton && i == 1) {
					html += '<button type="button" class="active" aria-label="Page ' + i + '">' + i + '</button>';
				} else {
					html += '<button type="button" aria-label="Page ' + i + '">' + i + '</button>';
				}
				
				html += '</li>';
			}

			if (5 < totalPage && lastPage < totalPage) {
				html += '<li>';
				html += '<span class="dot">...</span>';
				html += '</li>';
				html += '<li>';
				html += '<button type="button" aria-label="Page ' + totalPage + '">' + totalPage + '</button>';
				html += '</li>';
			}
			
			if (firstPage == 1) {
				$thisColumn.find('.prev').prop('disabled', true);
			} else {
				$thisColumn.find('.prev').prop('disabled', false);
			}

			if (lastPage == totalPage || totalPage <= 5) {
				$thisColumn.find('.next').prop('disabled', true);
			} else {
				$thisColumn.find('.next').prop('disabled', false);
			}

			$thisColumn.find('.pagination ul').html(html);
		},
		addAriaRoldAttr: function($el){
			!$el.find(".item-list").prop("role") && $el.find(".item-list").attr("role", "list");
			$el.find(".item").each(function(){
				!$(this).prop("role") && $(this).attr("role", "listitem");
			})
		},
		addEvent: function(){
			// tab event for mobile
			results.$tabs.on({
				click: function(){
					var _target = this.getAttribute('data-target');
					$(this).addClass('active').siblings().removeClass('active');
					results.$tabContents.filter('.'+_target).addClass('active')
						.siblings().removeClass('active');
					// 
				}
			}, 'button');
			// post detail page submit
			results.$carouselWrappers.on({
				click: function(e){
					e.preventDefault();
					var action = e.currentTarget.getAttribute('href'),
						$wrapper = $(e.currentTarget).closest('.item-column');
					var sortField = $wrapper.find('input[name="sorting"]').get(0),
						// pageField = $wrapper.find('input[name="page"]').get(0),
						resultSeqField = $(e.currentTarget).closest('.item').find('.resultSeq').get(0);
					SubmitdetailPage.sort.value = sortField.value;
					SubmitdetailPage.resultSeq.value = resultSeqField.value;
					SubmitdetailPage.action = action;
					//LGECI-538 add
					if(form.totalUse){
						SubmitdetailPage.superCategoryId.value = $('#superCategoryIdTotal').val();
						SubmitdetailPage.categoryId.value = $('#categoryIdTotal').val();
					}
					SubmitdetailPage.submit();
					// console.log($(SubmitdetailPage).serialize())
				}
			}, 'a');
			// pagination number click
			results.$pagination.find('ul').off().on({
				click: function(e) {
					var $thisButton = $(this),
						$thisPagination = $thisButton.closest('.pagination'),
						$thisColumn = $thisButton.closest('.item-column'),
						$thisCarousel = $thisColumn.find('.item-carousel');
					
					var page = $thisButton.html();

					$thisColumn.find('.page').val(page);

					results.callData($thisColumn, $thisCarousel);
					results.drawPaging($thisColumn, $thisButton);
					$thisPagination.find('li button').removeClass('active');
					$thisPagination.find('li button[aria-label="Page '+ page +'"]').addClass('active');
				}
			}, 'button');
			// pagination prev or next click
			results.$pagination.off().on({
				click: function(e) {
					var $thisButton = $(this),
						$thisColumn = $thisButton.closest('.item-column');
					
					results.drawPaging($thisColumn, $thisButton);
				}
			}, '.prev, .next');
			//LGECI-538 START
			results.$expander.on('click',function(){
				var $thisButton = $(this),
					$thisColumn = $thisButton.closest('.item-column'),
					$thisCarousel = $thisColumn.find('.item-carousel');
				
				var page = $thisButton.val();
				page = +page+1;
				$thisButton.val(page);
				$thisColumn.find('.page').val(page);
				results.callMobileData($thisColumn, $thisCarousel, $thisButton);
				if(page == $thisColumn.find('.pagination ul li button').last().text()){
					$thisButton.parent().removeClass('visible-mobile');
					$thisButton.attr("style","display:none");
				}
			});
			//LGECI-538 END
		}
	};
	// 200402 END 전호근 - pagination 추가 관련
	
	form.init();
	results.init();
	
	/* LGEBR-94 : 20200703 add */
	// page : solution slick scripts
	if(!document.querySelector('.resource-select-image-wrap')) return false;

	var isRTL = $('html').attr('dir') == 'rtl' ? true : false;

	var slickOption = {
		rtl : isRTL,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		arrows : true,
		dots: true,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows : true
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows : false
			}
		}],
		prevArrow: carouselOptions.bigAnglePrev, // common.js variable
		nextArrow: carouselOptions.bigAngleNext // common.js variable
	};

	if ( isRTL ){
		slickOption.prevArrow = carouselOptions.bigAngleNext;
		slickOption.nextArrow = carouselOptions.bigAnglePrev;
	}
	
	var $obj = $('.resource-select-image-wrap');
	var $slick = $obj.find('.product-type-gp .items');
	var url = $slick.data().url;
	var targetUrl = $slick.data().targetUrl;
	var categoryArray = null;

	var $prevPanel = $('.search-depth-stack').hide().css('height', '0px').addClass('active');
	var $prevBtn = $prevPanel.find('.prev-step');
	var $parentName = $prevPanel.find('.name-of-phase');

	$prevBtn.on('click', function(){
		$prevPanel.fadeOut(200,function(){
			slickInit();
		}).animate({
			height:'0px'
		}, 200, function(){
			//$prevPanel.removeClass('active');
		});

		$slick.find(".slick-track").css("opacity", "1").animate({
			opacity:0
		}, 200, function(){
			$slick.find(".slick-track").stop().animate({
				opacity:1
			}, 300);
		});
	});

	function panelShow(){
		//$prevPanel.addClass('active');
		$prevPanel.animate({
			height:'40px'
		}, 200).fadeIn(200,function(){
			
		});
		$slick.find(".slick-track").css("opacity", "0").animate({
			opacity:1
		}, 400);
	}


	function slickAddItem( item ){
		$slick.slick('slickAdd', item );
	}

	function superItemClickHandler( e ){
		e.preventDefault();
		
		var itemData = e.data;
		var hasList = (!!itemData.list.length);
		if(e.originalEvent){
			form.$topic.removeClass('active');
			SubmitdetailPage.superCategoryId.value = $(this).find('a').data().val;
			SubmitdetailPage.categoryId.value = '';
			SubmitdetailPage.symptom.value = '';
			SubmitdetailPage.subsymptom.value = '';
			form.categoryId.value = '';
			form.symptom.value = '';
			form.subsymptom.value = '';
			form.symptom.disabled = true;
			form.subsymptom.disabled = true;		
		
			form.$selectors.trigger('chosen:updated');
		}
		
		$('input[name=superCategoryId]').val($(this).find('a').data().val);
		
		// list 에 내용 없을시 페이지 이동처리
		if ( hasList ){
			// adobe tracking 추가 
			adobeTrackEvent('cs-category-browse', {page_event : {cs_category_browse : true}});
			slickRemoveItem();
			$(itemData.list).each(function(){
				var html = makeItem( this, false );
				slickAddItem( html );
			});
			$slick.slick('setPosition');
	
			$parentName.text( itemData.name );
	
			panelShow();
		}
	}

	function subItemClickHandler( e ){
		e.preventDefault();
		$('input[name=categoryId]').val($(this).find('a').data().val);
		form.$topic.addClass('active');
		SubmitdetailPage.categoryId.value = $(this).find('a').data().val;
		SubmitdetailPage.symptom.value = '';
		SubmitdetailPage.subsymptom.value = '';
		form.symptom.value = '';
		form.subsymptom.value = '';
		form.subsymptom.disabled = true;
		form.$selectors.trigger('chosen:updated');
		
		var param = xssfilter($(form.el).serialize());
		var url = targetUrl;
		ajax.noCacheCall(url, param, 'json', function (data) {
			if (data) {
				category.creatOptions(form.symptom, data);
			}
		});
		$(form.symptom).trigger('chosen:updated');
		
		form.doSubmit(this.querySelector('a'));
	}
	
	var category = {creatOptions: function (t, dataObj) {
		var html = '';
		// selectbox placeholder
		html += '<option value="" disabled selected>' + t.getAttribute('data-placeholder') + '</option>';

		if ((JSON.stringify(dataObj) == '{}' || dataObj.length == 0) || JSON.stringify(dataObj) == undefined) {
			$(t).html(html);
			t.setAttribute('disabled', 'disabled');
		} else {
			for (var key in dataObj) {
				var text, val;

				if (typeof dataObj[key] == "object") {
					for (var k in dataObj[key]) {
						text = dataObj[key][k];
						val = k;
					}

				} else {
					text = dataObj[key],
					val = key; // jshint ignore:line
				}

				if (val == null || val == '') {
					html += '<option value="' + val + '" disabled>' + text + '</option>';
				} else {
					html += '<option value="' + val + '">' + text + '</option>';
				}
			}
			$(t).html(html);
			t.removeAttribute('disabled');
		}
		$(t).trigger('chosen:updated');
	}}

	function slickRemoveItem(){
		// slick 초기화
		$slick.slick('slickRemove', null, null, true);
	}

	function makeItem( itemData, isSuper ){
		var html = '<div class="item">';
		html += '<div class="visual" aria-hidden="true">';
		html += '<a href="#" data-val="'+ itemData.categoryID +'" aria-label="'+ itemData.name +'" data-link-area="cs_category_browse" data-link-name="'+ itemData.name +'">';
		html += '<div class="image-box">';
		html += '<span><img data-src="'+ itemData.image +'" class="lazyload pc" alt="" />';
		html += '<img data-src="'+ itemData.image +'" class="lazyload mobile" alt="" />';
		html += '</span>';
		html += '</div>';
		html += '<span class="text">'+ itemData.name +'</span>';
		html += '</a>';
		html += '</div>';
		html += '</div>';
		
		var item = $(html);

		if (isSuper){
			item.find('a').attr('role', 'button').attr('data-area', 'superCategorySelect_hl');
		}else{
			item.find('a').attr('data-area', 'subCategorySelect_hl');
		}

		if ( isSuper ){
			item.on('click', itemData, superItemClickHandler );
		} else {
			item.on('click', itemData, subItemClickHandler );
		}

		return item;
	}

	function slickInit(){
		// category 정보가 없을때만
		if (!!categoryArray == false ){
			ajax.call(url, {}, 'json', function(data){
				categoryArray = data;

				$slick.slick( slickOption );
				slickRemoveItem();
				$(categoryArray).each(function(){
					var html = makeItem( this, true );
					slickAddItem( html );
				});
				$slick.slick('setPosition');
				var length = $slick.find('.item').length;
				
				var param = getUrlParams();
				var superCategoryId = $('#inputSuperCategorySelect_hl').val();
				var categoryId = $('#inputSubCategorySelect_hl').val();
				var symptom = $('#inputSymptom_hl').val();
				var subsymptom = $('#inputSubsymptom_hl').val();
				
				if( (param != {} && param.superCategoryId) || superCategoryId != ''){
					$slick.find('.item').each(function(){
						if(($(this).find('a').data('val') == param.superCategoryId) || $(this).find('a').data('val') == superCategoryId){
							$(this).find('a').click();
							$('input[name=superCategoryId]').val($(this).find('a').data('val'));
							return false;
						}
					});
					
					if(param.categoryId || categoryId != ''){
						$('input[name=categoryId]').val(param.categoryId? param.categoryId : categoryId );
					}
				}
				
			});
		} else {
			
			slickRemoveItem();
			$(categoryArray).each(function(){
				var html = makeItem( this, true );
				slickAddItem( html );
			});

			$slick.slick('setPosition');
			var length = $slick.find('.item').length;
		}
	}
	
	function getUrlParams() {
	    var params = {};
	    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
	    return params;
	}
	
	// scripts for solutions 
	var solutionCategoryArea = $('.category-browse-area');
	if(solutionCategoryArea.length>0) {
		var btnChooseBoxOpen = solutionCategoryArea.find('.btn-open'),
			btnChooseBoxClose = solutionCategoryArea.find('.btn-close'),
			chooseBoxArea = solutionCategoryArea.find('.category-content');

		btnChooseBoxOpen.find('button').on('click', function(event) {
			event.preventDefault();
			chooseBoxArea.addClass('active');
			btnChooseBoxOpen.hide();
			// slick repositioning
			slickInit();

			chooseBoxArea.attr('tabindex', -1).focus();
		});
		btnChooseBoxClose.find('button').on('click', function(event) {
			event.preventDefault();
			chooseBoxArea.removeClass('active');
			btnChooseBoxOpen.show();
			$prevPanel.fadeOut();
		});
	}

	slickInit();
	/*// LGEBR-94 : 20200703 add */
});
